import axios from 'axios';
import { getCurrentPlantId } from './sessionManager';

// Safely read + parse a sessionStorage value
const readJSON = (key) => {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const safeHeader = (val) => {
  if (val === undefined || val === null) return undefined;
  // Strip characters that are invalid in HTTP header values
  return String(val).replace(/[\r\n]/g, '').slice(0, 200);
};

// Global axios interceptor to add plant_id + actor identity to all API requests
axios.interceptors.request.use((config) => {
  // Plant context
  const plantId = getCurrentPlantId();
  if (plantId) {
    if (!config.params) config.params = {};
    if (!config.params.plant_id) {
      config.params.plant_id = plantId;
    }
  }

  // Actor identity headers (for server-side audit logging)
  try {
    const userType = sessionStorage.getItem('userType') || 'regular';
    let actorId, actorName, actorRole;

    if (userType === 'vendor') {
      const vendor = readJSON('vendorInfo');
      actorId = vendor?.id;
      actorName = vendor?.username || vendor?.name;
      actorRole = 'Vendor';
    } else {
      const user = readJSON('user');
      const role = readJSON('role');
      actorId = user?.id;
      actorName = user?.username;
      actorRole = role?.name;
    }

    config.headers = config.headers || {};
    const setH = (k, v) => { const s = safeHeader(v); if (s) config.headers[k] = s; };
    setH('X-User-Id', actorId);
    setH('X-Username', actorName);
    setH('X-User-Role', actorRole);
    setH('X-User-Type', userType);
    setH('X-Session-Token', sessionStorage.getItem('sessionToken'));
  } catch {
    // never block a request because of audit header issues
  }

  return config;
});

export default axios;
